import { render } from "./AdminDeviceCreate.vue?vue&type=template&id=188d2378&ts=true&lang=true"
import script from "./AdminDeviceCreate.vue?vue&type=script&lang=ts"
export * from "./AdminDeviceCreate.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__